import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { hasSomePermission } from "@/modules/auth/lib/permissions";

export const Route = createFileRoute("/__authed/m/stock")({
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;

		if (!hasSomePermission(user, ["see_material_groups", "see_client_materials"])) {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: Outlet,
});
